/*
  Native Shopify discount code field for the cart page and cart drawer.
  Applies and clears codes through /cart/update.js, which is Shopify's own cart
  endpoint, so any code type the store issues is honored and checkout sees it.

  The cart is refreshed in place with the theme's own "cart:build" event, which
  every theme.CartForm listens for (cart page and drawer both). A page reload
  would close the drawer and drop the shopper back on the page underneath it.
*/
(function () {
  if (window.__cosCartDiscountReady) return;
  window.__cosCartDiscountReady = true;

  var MESSAGES = {
    empty: 'Enter a code first.',
    invalid: 'That code is not valid for this cart.',
    failed: 'Could not apply that code. Try again.'
  };

  function field(el) {
    return el ? el.closest('[data-cart-discount]') : null;
  }

  function setMessage(root, text, isError) {
    var box = root.querySelector('[data-cart-discount-message]');
    if (!box) return;
    box.textContent = text || '';
    box.hidden = !text;
    box.classList.toggle('cart__discount-message--error', !!isError);
  }

  function setBusy(root, busy) {
    var button = root.querySelector('[data-cart-discount-apply]');
    if (button) button.disabled = !!busy;
  }

  // Both fields (page and drawer) render on the same document, so an applied or
  // removed code has to show on each of them, not only the one that was used.
  function setApplied(code) {
    var roots = document.querySelectorAll('[data-cart-discount]');
    for (var i = 0; i < roots.length; i++) {
      var box = roots[i].querySelector('[data-cart-discount-applied]');
      var label = roots[i].querySelector('[data-cart-discount-applied-code]');
      if (label) label.textContent = code ? code + ' applied' : '';
      if (box) box.hidden = !code;
      roots[i].setAttribute('data-has-discount', code ? 'true' : 'false');
    }
  }

  function clearInputs() {
    var inputs = document.querySelectorAll('[data-cart-discount-input]');
    for (var i = 0; i < inputs.length; i++) inputs[i].value = '';
  }

  // theme.CartForm binds "cart:build" in its own init, so this re-renders the
  // line items, cart-level discounts, savings line and subtotal wherever a cart
  // form is on the page. The drawer stays open and nothing navigates.
  function refreshCart(cart) {
    document.dispatchEvent(new CustomEvent('cart:build'));
    if (cart) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }

  function getCart() {
    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart.js'
      : '/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function updateDiscount(code) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code })
    }).then(function (r) { return r.json(); });
  }

  function appliedCode(cart) {
    var codes = (cart && cart.discount_codes) || [];
    for (var i = 0; i < codes.length; i++) {
      if (codes[i].applicable) return codes[i].code;
    }
    return null;
  }

  function rejected(cart, code) {
    var codes = (cart && cart.discount_codes) || [];
    for (var i = 0; i < codes.length; i++) {
      if (codes[i].code.toUpperCase() === code.toUpperCase() && !codes[i].applicable) return true;
    }
    return false;
  }

  function apply(root) {
    var input = root.querySelector('[data-cart-discount-input]');
    if (!input) return;
    // Shopify redeems codes case insensitively, but it echoes back whatever was
    // submitted, so normalize before sending to keep the applied label clean.
    var code = (input.value || '').trim().toUpperCase();
    if (!code) {
      setMessage(root, MESSAGES.empty, true);
      input.focus();
      return;
    }

    setBusy(root, true);
    setMessage(root, '');

    // Read the current code first: /cart/update.js replaces the whole code set,
    // so a rejected code would otherwise silently drop a working one.
    var previous = null;
    getCart()
      .then(function (cart) {
        previous = appliedCode(cart);
        return updateDiscount(code);
      })
      .then(function (cart) {
        if (rejected(cart, code)) {
          setMessage(root, MESSAGES.invalid, true);
          return updateDiscount(previous || '').then(function (restored) {
            setApplied(appliedCode(restored));
            refreshCart(restored);
            setBusy(root, false);
          });
        }
        setApplied(appliedCode(cart));
        clearInputs();
        refreshCart(cart);
        setBusy(root, false);
      })
      .catch(function () {
        setMessage(root, MESSAGES.failed, true);
        setBusy(root, false);
      });
  }

  function remove(root) {
    setBusy(root, true);
    setMessage(root, '');
    updateDiscount('')
      .then(function (cart) {
        setApplied(null);
        clearInputs();
        refreshCart(cart);
        setBusy(root, false);
      })
      .catch(function () {
        setMessage(root, MESSAGES.failed, true);
        setBusy(root, false);
      });
  }

  function hydrate() {
    var roots = document.querySelectorAll('[data-cart-discount][data-has-discount="true"]');
    if (!roots.length) return;
    getCart().then(function (cart) {
      var code = appliedCode(cart);
      if (code) setApplied(code);
    }).catch(function () {});
  }

  document.addEventListener('click', function (event) {
    var applyButton = event.target.closest('[data-cart-discount-apply]');
    if (applyButton) {
      event.preventDefault();
      apply(field(applyButton));
      return;
    }
    var removeButton = event.target.closest('[data-cart-discount-remove]');
    if (removeButton) {
      event.preventDefault();
      remove(field(removeButton));
    }
  });

  // The field sits inside the cart form, so Enter would otherwise submit to checkout.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target.closest('[data-cart-discount-input]');
    if (!input) return;
    event.preventDefault();
    apply(field(input));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate);
  } else {
    hydrate();
  }
})();
